<div class="sidebar-picker-header my-4 px-6">
  <soft-ds-tabs
    class="sidebar-picker-view-tabs "
    [tabs]="viewTabs()"
    [value]="view()"
    (valueChange)="view.set($event ?? 'all')"
    size="sm"
    layout="fill" />
</div>
<div class="mt-4 sidebar-picker-body px-6">
  <div class="sidebar-picker-search-container">
    <soft-ds-icon
      name="fa-solid fa-magnifying-glass"
      class="sidebar-picker-search-icon"
      size="sm"
      aria-hidden="true"
    />
    <input
      #searchInput
      type="text"
      class="sidebar-picker-search ds-body-2"
      role="searchbox"
      [placeholder]="'#CORE_FILTER.MULTI_SELECT.SEARCH' | translate"
      [value]="search()"
      (input)="onSearchInput($event)"
      (keydown)="onSearchKeydown($event)"
    />
    @if (search()) {
      <button
        type="button"
        class="sidebar-picker-search-clear"
        aria-label="Clear search"
        (click)="onPickerSearchClear()"
      >
        <soft-icon name="fa-solid fa-xmark" size="xs" aria-hidden="true" />
      </button>
    }
  </div>
  <div
    #pickerList
    class="sidebar-picker-list"
    role="listbox"
    aria-multiselectable="true"
    tabindex="-1"
    (scroll)="onScroll($event)"
  >
    @switch (view()) {
      @case ('all') {
        @if (valuesResource.status() === 'error') {
          <p>Error: {{ valuesResource.error() | json }}</p>
        } @else if (values().length === 0 && valuesResource.isLoading()) {
          <div class="flex flex-col gap-2" aria-live="polite">
            @for (row of loadingRows(); track row) {
              <soft-ds-loading-skeleton
                width="100%"
                height="1rem"
                radius="var(--ds-radius-md)"
              />
            }
          </div>
        } @else {
          <div class="flex flex-col gap-2">
            @for (value of values(); track value; let i = $index) {
              @if(value | isDefinedNotEmpty) {
                <div
                  class="sidebar-picker-row flex flex-row gap-2 cursor-pointer"
                  [class.is-highlighted]="highlightedIndex() === i"
                  [attr.data-option-index]="i"
                  (click)="toggleValue(value)">
                  <soft-checkbox [checked]="isSelected(value)"
                                 (click)="toggleValue(value); $event.stopPropagation(); $event.preventDefault()"></soft-checkbox>
                  @let label = $any(item().formatter)($any(value));
                  @if (label | isDefinedNotEmpty) {
                    <span>  {{ label }} </span>
                  } @else {
                    <span class="ds-text-secondary"> {{ 'Leer' }} </span>
                  }
                </div>
              }
            }
          </div>
          @if (valuesResource.isLoading()) {
            <div class="flex justify-center py-2" aria-live="polite">
              <soft-loading-spinner />
            </div>
          }
        }
      }
      @case ('selected') {
        <div class="flex flex-col gap-2">
          @for (value of selectedValues(); track value; let i = $index) {
            <div
              class="sidebar-picker-row flex flex-row gap-2 cursor-pointer"
              [class.is-highlighted]="highlightedIndex() === i"
              [attr.data-option-index]="i"
              (click)="toggleValue(value)">
              <soft-checkbox [checked]="isSelected(value)"
                             (click)="toggleValue(value); $event.stopPropagation(); $event.preventDefault()"></soft-checkbox>

              @let label = $any(item().formatter)(value);
              @if (label | isDefinedNotEmpty) {
                <span>  {{ label }} </span>
              } @else {
                <span class="ds-text-secondary"> {{ 'Leer' }} </span>
              }
            </div>
          }
        </div>
      }
    }
  </div>
</div>

